export default __webpack_public_path__ + "static/media/logo-small.f41ff6f8.png";